import axios from "axios";
import { useState } from "react";
import { UrlApi } from "../../../services/apirest";

const useMatafuegos = () => {
  const [inspections, setInspections] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchMatafuegos = async (plantaId) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${UrlApi}/mp_matafuegos/byplanta/${plantaId}`
      );

      if (response.status === 204) {
        // Manejar el caso de 'No Content' si no hay equipos
        setInspections([]);
        setLoading(false);
        return;
      }

      if (!response.ok) {
        throw new Error("Error en la red o en el servidor.");
      }

      const data = await response.json();
      console.log(data);

      // Formatear los datos para el estado del frontend
      const formattedArray = data.map((curr) => ({
        id: curr.id,
        id_planta: curr.id_planta,
        equipo: curr.equipo,
        sector: curr.sector,
        zona: curr.zona,
        serie_equipo: curr.serie_equipo,
        tipo: curr.tipo,
        capacidad: curr.capacidad,
        fechavto: curr.fechavto,
        inspeccion: {
          id: curr.inspeccion_id,
          cartel: !!curr.cartel,
          manometro: !!curr.manometro,
          manguera: !!curr.manguera,
          caja: !!curr.caja,
          hasfechavto: !!curr.inspeccion_vto,
          fecha_inspeccion: curr.fecha_inspeccion,
          fecha_inspeccion_mes: curr.fecha_inspeccion_mes,
        },
        correctivo: {
          id: curr.correctivo_id,
          titulo: curr.titulo,
          tarea: curr.tarea,
          vencimiento: curr.vencimiento,
          realizado: curr.realizado,
        },
      }));
      setInspections(formattedArray);
    } catch (err) {
      console.log("Error fetching matafuegos:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleItemCheck = async (extinguisherId, itemId, isChecked) => {
    // 1. Validaciones iniciales
    if (!extinguisherId || !itemId || isChecked === undefined) {
      return;
    }

    const previousInspections = [...inspections]; // ⏪ Guarda una copia del estado actual

    // 2. Actualización optimista del UI 🚀
    // Actualiza el estado como si la llamada a la API ya hubiera tenido éxito.
    // La interfaz del usuario se verá actualizada al instante.
    setInspections((prev) =>
      prev.map((ext) =>
        ext.id === extinguisherId
          ? {
              ...ext,
              inspeccion: {
                ...ext.inspeccion,
                [itemId]: isChecked,
              },
            }
          : ext
      )
    );

    console.log(
      "Updating item:",
      { extinguisherId, itemId, isChecked },
      "itemId:",
      itemId,
      "isChecked:",
      isChecked
    );
    // 2. Lógica para interactuar con la API (¡la parte clave!)
    try {
      const response = await fetch(
        `${UrlApi}/mp_matafuegos/check/${extinguisherId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            itemId,
            isChecked,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(
          "Error al actualizar la inspección en la base de datos."
        );
      }

      const result = await response.json();
      console.log(result.msg); // Muestra el mensaje de éxito del backend
    } catch (error) {
      // 4. Manejo de errores y reversión del UI ❌
      // Si hay un error, revertimos el estado al valor que tenía antes.
      console.error("Error en la conexión con la API:", error);
      alert(
        "Hubo un error al guardar la inspección. Por favor, inténtelo de nuevo."
      );
      // Revertimos el estado usando la copia guardada
      setInspections(previousInspections);
    }
  };
  return {
    inspections,
    fetchMatafuegos,
    handleItemCheck,
    loading,
  };
};

export default useMatafuegos;
